import * as React from "react";
import styled from "styled-components";
import { toast } from "react-toastify";

import { Button } from "src/library/components/Button";
import { LoadingSpinner } from "src/library/components/LoadingSpinner";
import {
  BasicModal,
  BasicModalProps
} from "src/library/components/Modal/BasicModal";
import { ErrorNotice } from "src/core/shared/components/ErrorNotice";
import {
  ExportCustomerParams,
  useCustomerApi
} from "src/core/customers/api/customers.api";

import { CustomerMultiSelect } from "./CustomerMultiSelect";

type CustomerDropsExportModalProps = Pick<BasicModalProps, "onDismiss" | "open">;

export const CustomerDropsExportModal: React.ReactFCWithChildren<CustomerDropsExportModalProps> = ({ onDismiss, open }) => {
  const [ exportDropsResponse, exportDrops ] = useCustomerApi("EXPORT_DROPS");
  const [ dropExportFilters, setDropExportFilters ] = React.useState<ExportCustomerParams["filters"]>({});

  // handle the response and open the file to trigger the download
  React.useEffect(() => {
    if (exportDropsResponse.data) {
      onDismiss();
      toast.success(exportDropsResponse.data.message);
    }
  // Ignore other dependencies, we only care for the defined ones below
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ exportDropsResponse.data ]);

  return (
    <StyledBasicModal
      title="Export Customer Drops"
      open={open}
      onDismiss={onDismiss}
    >
      {exportDropsResponse.error && (
        <ErrorNotice
          message={exportDropsResponse.error.message}
          type="error"
        />
      )}

      {exportDropsResponse.pending ? (
        <LoadingSpinner type="circular" />
      ) : (
        <>
          <CustomerMultiSelect
            onCustomersChange={({ customersSelected }) => setDropExportFilters({ customerId: { $in: customersSelected.map(cid => parseInt(cid, 10)) } })}
          />

          <Button
            className="submit-button"
            onClick={() => {
              exportDrops({ filters: dropExportFilters });
            }}
          >
            Export
          </Button>
        </>
      )}
    </StyledBasicModal>
  );
};

const StyledBasicModal = styled(BasicModal)`
  .submit-button {
    margin-top: ${({ theme }) => theme.spacing.margins.md};
  }
`;
